import { WorkspaceList } from './components/workspace-list';
import { DescriptionHeader } from '../../features/user/components/description-header';
import { useEffect } from 'react';
import { uiStore } from '../../core/stores/ui-store';

export const WorkspacesRoute = () => {
  useEffect(() => {
    uiStore.pageTitle = {
      label: 'Workspaces',
    };

    return () => {
      uiStore.pageTitle = {
        label: '',
      };
    };
  });

  return (
    <>
      <DescriptionHeader title={'Workspaces'} />
      <WorkspaceList />
    </>
  );
}
